/**
 * Convert an array of strings to an object
 */
export function stringArrayToObject(arrayOfStrings: string[]): Record<string, any> {
  return arrayOfStrings.reduce(
    (acc, cur, ndx, arr) => {
      if (ndx % 2 === 0) {
        return acc;
      }

      const previous = arr[ndx - 1];

      acc[previous] = cur;

      return acc;
    },
    <Record<string, any>>{},
  );
}
